/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */

import BusinessIcon from '@mui/icons-material/Business';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import SettingsIcon from '@mui/icons-material/Settings';

export default [
  {
    pages: [
      {
        title: 'DASHBOARD',
        href: '/admin/dashboard/',
        icon: DashboardIcon,
        disabled: false,
      },
      {
        title: 'MANAGE',
        icon: PlaylistAddCheckIcon,
        children: [
          {
            title: 'OVERVIEW',
            href: '/admin/orders/overview/',
            disabled: true,
          },
          {
            title: 'ORDERS',
            href: '/admin/manage/orders/',
          },
          {
            title: 'BATCHES',
            href: '/admin/manage/batches/',
          },

        ],
      },
      {
        title: 'PRODUCTS',
        icon: LocalMallIcon,

        children: [
          {
            title: 'SKU',
            href: '/admin/products/sku',
          },
          {
            title: 'BUNDLES',
            href: `/admin/bundles`,
          },

        ],
      },
      {
        title: 'SUPPORT',
        icon: HeadsetMicIcon,
        href: '/admin/support/tickets',
      },
      {
        title: 'ORGANISATIONS',
        href: '/admin/organisations/summary',
        icon: BusinessIcon,
      },

      {
        title: 'ACCOUNTING',
        icon: CreditCardIcon,
        children: [
          {
            title: 'DASHBOARD',
            href: '/admin/accounting/dashboard',
          },
          {
            title: 'INVOICES',
            href: '/admin/accounting/invoices',
          },
          {
            title: 'SALES AGENT',
            href: '/admin/accounting/sales-agents',
          },
          {
            title: 'OTHER',
            href: '/admin/accounting/others',
          },
        ],
      },
      {
        title: 'WAREHOUSE',
        icon: HomeWorkIcon,
        children: [

          {
            title: 'SUMMARY',
            href: '/admin/warehouses/summary',

          },
          {
            title: 'INVENTORY',
            href: '/admin/warehouses/inventory',
          },
          {
            title: 'SUPPLIERS',
            href: '/admin/warehouses/suppliers',

          },
        ],
      },

      {
        title: 'SETTINGS',
        href: '/admin/settings/',
        icon: SettingsIcon,
      },
    ],
  },

];
